
import { FiUsers } from "react-icons/fi";
import { FaBed, FaCalendarCheck, FaCog } from "react-icons/fa";
import { MdOutlinePolicy, MdMeetingRoom, MdMiscellaneousServices, MdArticle, MdTravelExplore } from "react-icons/md";

export const loginSlidesEN = [
  "Explore the world with comfort and ease. Book your flights, hotels, and tours in one seamless experience. LiBooking brings you closer to your next adventure with trusted service, flexible options, and stunning destinations waiting to be discovered by you.",
  "Plan your dream vacation without stress. From luxury hotels to last-minute flights, we’ve got you covered. LiBooking makes every journey easier, faster, and more enjoyable. Your travel story starts here, wherever you want to go.",
  "Wherever life takes you, LiBooking is your trusted companion. Enjoy curated stays, seamless ticket booking, and exceptional travel packages tailored for you. It’s more than booking — it’s an experience built around your needs.",
  "Turn moments into memories with LiBooking. Browse exclusive deals, explore endless destinations, and manage everything in one place. Whether it's a solo trip or a family getaway, we make travel effortless and exciting for everyone.",
  "Your gateway to the world is just a click away. Discover, plan, and book hotels, flights, and activities with confidence. With smart filters, real-time updates, and secure checkout, LiBooking is the smarter way to travel.",
];
export const loginSlidesAR = [
  "استكشف العالم بسهولة وراحة. احجز رحلاتك وفنادقك وجولاتك في تجربة واحدة سلسة. LiBooking تقربك من مغامرتك القادمة بخدمة موثوقة، وخيارات مرنة، ووجهات مذهلة بانتظارك.",
  "خطط لعطلتك المثالية بدون توتر. من الفنادق الفاخرة إلى الرحلات في اللحظة الأخيرة، نحن هنا لخدمتك. LiBooking تجعل كل رحلة أسهل وأسرع وأكثر متعة. رحلتك تبدأ من هنا.",
  "أينما تأخذك الحياة، LiBooking هو رفيقك الموثوق. استمتع بإقامات مختارة، وحجوزات تذاكر سلسة، وباقات سفر استثنائية مصممة خصيصًا لك. الأمر أكثر من حجز، إنها تجربة متكاملة.",
  "حوّل اللحظات إلى ذكريات مع LiBooking. تصفح عروض حصرية، واستكشف وجهات لا نهائية، وادِر كل شيء في مكان واحد. سواء كانت رحلة فردية أو عائلية، نجعل السفر سهلاً وممتعًا للجميع.",
  "بوابتك إلى العالم بضغطة زر. اكتشف، وخطط، واحجز فنادقك، ورحلاتك، وأنشطتك بكل ثقة. مع فلاتر ذكية، وتحديثات فورية، ودفع آمن، LiBooking هو الخيار الأذكى للسفر.",
];
export const navLinks = [
  { name_en: "Home", name_ar: "الرئيسية", path: "/" },
  { name_en: "Popular Stays", name_ar: "الاقامات الشائعة", path: "/stays" },
  { name_en: "Offers", name_ar: "العروض", path: "/offers" },
  { name_en: "About Us", name_ar: "من نحن", path: "/about" },
];
export const occasions = [
  { label_ar: "حفل زفاف", label_en: "Wedding", value: "wedding" },
  { label_ar: "خطوبة", label_en: "Engagement", value: "engagement" },
  { label_ar: "عيد ميلاد", label_en: "Birthday", value: "birthday" },
  { label_ar: "مؤتمر", label_en: "Conference", value: "conference" },
  { label_ar: "ندوة", label_en: "Seminar", value: "seminar" },
  {
    label_ar: "اجتماع عمل",
    label_en: "Business Meeting",
    value: "business_meeting",
  },
  { label_ar: "حفل تخرج", label_en: "Graduation", value: "graduation" },
  { label_ar: "حفل عائلي", label_en: "Family Event", value: "family_event" },
  { label_ar: "عقيقة", label_en: "Aqeeqah", value: "aqeeqah" },
  {
    label_ar: "إفطار رمضاني",
    label_en: "Ramadan Iftar",
    value: "ramadan_iftar",
  },
  { label_ar: "عرض منتج", label_en: "Product Launch", value: "product_launch" },
  { label_ar: "معرض", label_en: "Exhibition", value: "exhibition" },
  { label_ar: "ورشة عمل", label_en: "Workshop", value: "workshop" },
  { label_ar: "حفل خيري", label_en: "Charity Event", value: "charity_event" },
];
export const helpLinks = [
  {
    name_en: "Contact Us",
    name_ar: "تواصل معنا",
    path: "/contact",
  },
  {
    name_en: "Terms & Conditions",
    name_ar: "الشروط والأحكام",
    path: "/terms",
  },
  {
    name_en: "Privacy Policy",
    name_ar: "سياسة الخصوصية",
    path: "/terms",
  },
];
export const PayMethods = [
  { image: "/asset/edfa.jpg" },
  { image: "/asset/masterCard.png" },
  { image: "/asset/mastro.png" },
  { image: "/asset/paypal.png" },
  { image: "/asset/visa.png" },
];


export const adminPageLinks = [

  //{ title_ar: "الإحصائيات", title_en: "Statistics", link: "/dashboard", icon: <FaChartBar /> },
  { title_ar: "الحجوزات", title_en: "Bookings", link: "/dashboard", icon: <FaCalendarCheck /> },
  // { title_ar: "حجوزات الرحلات", title_en: "Trip Bookings", link: "/dashboard/trip-bookings", icon: <GiPalmTree  /> },
  { title_ar: "الخدمات", title_en: "Services", link: "/dashboard/services", icon: <MdMiscellaneousServices /> },
  { title_ar: "المقالات", title_en: "Articles", link: "/dashboard/articles", icon: <MdArticle /> },
  { title_ar: "السياسات", title_en: "Policies", link: "/dashboard/policy", icon: <MdOutlinePolicy /> },
  { title_ar: " القاعات", title_en: "Hall ", link: "/dashboard/hall", icon: <MdMeetingRoom /> },
  { title_ar: "الإقامات", title_en: "Stays", link: "/dashboard/stays", icon: <FaBed /> },
  { title_ar: "المستخدمين", title_en: "Users", link: "/dashboard/users", icon: <FiUsers /> },
  //{ title_ar: "الرحلات الجوية", title_en: "Flights", link: "/dashboard/flights", icon: <FaPlaneDeparture /> },
  { title_ar: "الرحلات", title_en: "Trips", link: "/dashboard/trips", icon: <MdTravelExplore /> },
  { title_ar: "الإعدادات", title_en: "Settings", link: "/dashboard/settings", icon: <FaCog /> }
];
export const placeTypes = [
  { id: 1, title_ar: "اقامة", title_en: "Stay", value: "Stay" },
  { id: 2, title_ar: "قاعة", title_en: "Hall", value: "Hall" },

]
export const subcategoryImages: { [key: string]: string } = {
  1: "/asset/hotel.jpg",
  2: "/asset/villas.jpg",
  3: "/asset/apartment.png",
  8: "/asset/resort.jpg",
  18: "/asset/restHouse.jpg",
}

export const peopleRanges = [
  {
    label_ar: "من 100 إلى 500",
    label_en: "100 - 500",
    value: "100-500",
  },
  {
    label_ar: "من 500 إلى 1000",
    label_en: "500 - 1000",
    value: "500-1000",
  },
  {
    label_ar: "من 1000 إلى 2000",
    label_en: "1000 - 2000",
    value: "1000-2000",
  },
  {
    label_ar: "أكثر من 2000",
    label_en: "+2000",
    value: "2000-null",
  },
]
export const menuItems = [
  {
    title_en: "My Profile",
    title_ar: "ملفي الشخصي",
    link: "",
    active: true,
  },
  {
    title_en: "Payment Cards",
    title_ar: "بطاقات الدفع",
    link: "/payment-cards",
  },
  {
    title_en: "Wallet",
    title_ar: "المحفظة",
    link: "/wallet",
  },
  {
    title_en: "Stay Bookings",
    title_ar: "حجوزات الإقامة",
    link: "/stay-bookings",
  },
  {
    title_en: "Halls Bookings",
    title_ar: "حجوزات القاعات",
    link: "/halls-bookings",
  },
  /*  {
     title_en: "Trips Bookings",
     title_ar: "حجوزات الرحلات",
     link: "/trips-bookings",
   },  */
  {
    title_en: "Security",
    title_ar: "الأمان",
    link: "/security",
  },/* 
  {
    title_en: "Help Center",
    title_ar: "مركز المساعدة",
    link: "/help-center",
  },*/
];
export const currencyCodes = ["LYD", "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTC", "BTN", "BWP", "BYN", "BYR", "BZD", "CAD", "CDF", "CHF", "CLF", "CLP", "CNY", "CNH", "COP", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GGP", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "IMP", "INR", "IQD", "IRR", "ISK", "JEP", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LTL", "LVL", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "STD", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XCD", "XDR", "XOF", "XPF", "YER", "ZAR", "ZMK", "ZMW", "ZWL"]

export const logos: Record<string, string> = {
  Visa: "/asset/visa.png",
  MasterCard: "/asset/mastercard.png",
  "American Express": "/asset/amex.png",
  Unknown: "/asset/card (1).png",
};
export const roomTypes = [
  { titleEn: "Single", typeAr: "منفردة" },
  { titleEn: "Delux", typeAr: "زوجية" },
  { titleEn: "Suite", typeAr: "جناح" },
  { titleEn: "Triple", typeAr: "ثلاثية" },
  { titleEn: "Standard Suite", typeAr: "جناح عادي" },
  { titleEn: "Duplex Suite", typeAr: "جناح دوبلكس" },
  { titleEn: "VIP Suite", typeAr: "جناح VIP" },
  { titleEn: "Presidential Suite", typeAr: "جناح رئاسي" },
  { titleEn: "Family Suite", typeAr: "جناح عائلي" },
  { titleEn: "Standard Twin", typeAr: "غرفة مزدوجة (سريرين)" },
  { titleEn: "Standard Single", typeAr: "غرفة فردية (سرير واحد)" },
  { titleEn: "Accessible", typeAr: "غرفة لذوي الاحتياجات الخاصة" },
  { titleEn: "Deluxe Sea View", typeAr: "غرفة رفيعة مطلة على البحر." },
  { titleEn: "Standard Sea View", typeAr: "غرفة عادية مطلة على البحر." },
  { titleEn: "Executive Suite A", typeAr: "جناح ممتاز  A" },
  { titleEn: "Deluxe Suite B", typeAr: "جناح رفيع  B" },
  { titleEn: "Double", typeAr: "غرفة مزدوجة" },
  { titleEn: "Deluxe twin single", typeAr: "غرفة ديلوكس سريرين مفرد" },
  { titleEn: "Premium king Room double", typeAr: "غرفة بريميوم كينج مزدوجة" },
  { titleEn: "Premium twin double", typeAr: "غرفة بريميوم سريرين مزدوجة" },
  { titleEn: "Premium king Room single", typeAr: "غرفة بريميوم كينج مفردة" },
  { titleEn: "Premium twin single", typeAr: "غرفة بريميوم سريرين مفردة" },
  { titleEn: "Executive suite", typeAr: "جناح تنفيذي" },
  { titleEn: "Ambassador suite", typeAr: "جناح السفير" },
  { titleEn: "Deluxe king Room double", typeAr: "غرفة ديلوكس كينج مزدوجة" },
  { titleEn: "Deluxe king Room single", typeAr: "غرفة ديلوكس كينج مفردة" },
  { titleEn: "Deluxe twin double", typeAr: "غرفة ديلوكس سريرين مزدوجة" }
];
export const durationOptions = [
  {
    value: 1,
    label_ar: 'الفترة الصباحية',
    label_en: 'Morning period'
  },
  {
    value: 2,
    label_ar: 'الفترة المسائية',
    label_en: 'Evening period'
  }
]
export const acceptedPaymentMethods = [
  { key: 1, label_en: "Cash", label_ar: "نقداً عند الوصول" },
  { key: 2, label_en: "Online Payment", label_ar: "دفع إلكتروني" },
];